import {
  TableHead,
  TableCell,
  TableSortLabel,
  TableRow,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './SortableTableHead.scss';

const defaultProps = {
  config: [],
  order: '',
  orderBy: '',
  onRequestSort: () => {},
};
const SortableTableHead = (props) => {
  const { config, order, orderBy, onRequestSort } = { ...defaultProps, ...filterUndefined(props) };
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className='sortable-table-head'>
      <TableRow>
        {config.map((headCell) => (
          <TableCell
            className='header'
            key={`header-${headCell.dataField}`}
            sortDirection={orderBy === headCell.dataField ? order : false}
            style={{ width: headCell.width }}
          >
            { headCell.noSort ? (
              <div className='nosort-label'>{headCell.title}</div>
            ) : (
              <TableSortLabel
                className='sort-label'
                active={orderBy === headCell.dataField}
                direction={orderBy === headCell.dataField ? order : 'asc'}
                onClick={createSortHandler(headCell.dataField)}
                aria-label={headCell.title ? `Sort by ${headCell.title}` : 'Sort by column'}
              >
                {headCell.title ? headCell.title : <div style={{ width: '20px', height: '20px' }} />}
              </TableSortLabel>
            )}

          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SortableTableHead;
